export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    mstOptionList: [
      {
        optClasCd: "OPT00001",
        optClasNm: "사이드메뉴",
        optClasKoNm: "사이드메뉴",
        optClasJpNm: "サイド11",
        optClasEnNm: "Side",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 1,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "001",
        optGbn: "03",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "001",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00004",
        optClasNm: "원두종류",
        optClasKoNm: "원두종류",
        optClasJpNm: "Type",
        optClasEnNm: "Type",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 4,
        optMultiUseYn: "Y",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "S003",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00005",
        optClasNm: "원두종류2",
        optClasKoNm: "원두종류2",
        optClasJpNm: "Type2",
        optClasEnNm: "Type2",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 5,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "S003",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00005",
        optClasNm: "원두종류2",
        optClasKoNm: "원두종류2",
        optClasJpNm: "Type2",
        optClasEnNm: "Type2",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 5,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "S004",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00006",
        optClasNm: "컵",
        optClasKoNm: "컵",
        optClasJpNm: "Cup",
        optClasEnNm: "Cup",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 6,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "Y",
        optGrpCd: "S003",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00007",
        optClasNm: "퍼스널옵션",
        optClasKoNm: "퍼스널옵션",
        optClasJpNm: "Personal Option",
        optClasEnNm: "Personal Option",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 7,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "Y",
        optGrpCd: "S003",
        optGbn: "01",
      },
      {
        optClasCd: "SOP00007",
        optClasNm: "퍼스널옵션",
        optClasKoNm: "퍼스널옵션",
        optClasJpNm: "Personal Option",
        optClasEnNm: "Personal Option",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 7,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "Y",
        optGrpCd: "S004",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택7",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택8",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택9",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택11",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택12",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택13",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택14",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택15",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택16",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00002",
        optClasNm: "사이즈선택16",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "002",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00009",
        optClasNm: "사이즈선택",
        optClasKoNm: "사이즈선택",
        optClasJpNm: "サイズ",
        optClasEnNm: " Size",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "SIZE001",
        optGbn: "01",
      },
      {
        optClasCd: "OPT00010",
        optClasNm: "사이드",
        optClasKoNm: "사이드",
        optClasJpNm: "サイズ",
        optClasEnNm: "Side",
        optClasCnNm: "",
        optClasTwNm: "",
        optClasType: "",
        optOrder: 2,
        optMultiUseYn: "N",
        optUrpc: 0,
        imgYn: "N",
        optGrpCd: "SIDE001",
        optGbn: "05",
      },
    ],
  },
};
